import { Expose, Type } from "class-transformer";
import { IsNumber, IsOptional, IsString, IsBoolean, ValidateNested } from "class-validator";
import GenericTableResponse from "../GenericTableResponse";

export class BookingFilesListItem {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  date!: string;
  @IsOptional()
  @IsString()
  @Expose()
  fileId!: string;
  @IsString()
  @Expose()
  fileExtension!: string;
  @IsString()
  @Expose()
  name!: string;
  @IsString()
  @Expose()
  parser!: string;
  @IsString()
  @Expose()
  sender!: string;
  @IsBoolean()
  @Expose()
  isProcessed!: boolean;
  @IsNumber()
  @Expose()
  tryParseCount!: number;
}

export class GetBookingFilesResponse extends GenericTableResponse<BookingFilesListItem> {
  @Type(() => BookingFilesListItem)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<BookingFilesListItem>;
}
